module.exports = __webpack_public_path__ + "images/wensink93eec67ea3a4414ecac2b9b858f297bd.png";